<template>
  <pane-view>
    <template v-slot:left>
      <carousel />
      <div
        class="back-btn-container hidden-sm-and-down"
        @click="$router.back()"
      >
        <v-icon class="back-chevron" color="white" size="48"
          >mdi-chevron-left</v-icon
        >
        <span class="back-text">Back</span>
      </div>
      <div class="copyright">
        &copy; {{ new Date().getFullYear() }} TeamBot LLC
      </div>
      <privacy-terms-modal />
    </template>
    <template v-slot:right>
      <div class="forgot-password-container">
        <div
          class="back-btn-container hidden-md-and-up"
          style="margin-left: -40px; margin-top: -20px"
          @click="$router.back()"
        >
          <v-icon class="back-chevron" color="white" size="48"
            >mdi-chevron-left</v-icon
          >
          <span class="back-text">Back</span>
        </div>
        <v-row style="height: 100%; align-items: center">
          <v-spacer />
          <v-col
            :cols="12"
            class="col-lg-7 col-xl-6 col-md-10 col-sm-12 col-xs-12"
          >
            <h1 class="text-center _title">Forgot Your Password?</h1>
            <p class="_subtitle">
              No problem. Enter your email address and we will send you a link
              to reset your password.
            </p>

            <div class="panel panel-default p20">
              <div class="form-group">
                <input
                  id="email"
                  v-model="email"
                  class="tb-input mt-4"
                  placeholder="Email"
                  type="text"
                />
                <!--                <input id='email' v-model="email" class='form-control' name='email' type='text'/>-->
              </div>
              <div class="form-group mt-3">
                <button
                  class="tb-primary-btn tb-primary-btn-full-width"
                  value="Submit"
                  @click="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </v-col>
          <v-spacer />
        </v-row>
        <snackbar :color="color" :snackbar="snackbar" :text="snackText" />
      </div>
    </template>
  </pane-view>
</template>
<script>
import axios from 'axios'
import snackbar from '../components/snackbar'
import PaneView from '@/template/PaneView.vue'
import Carousel from '@/components/carousel.vue'
import PrivacyTermsModal from '@/components/privacy-terms-modal.vue'

export default {
  name: 'reset-password',
  metaInfo: {
    title: 'Forgot Password'
  },
  components: {
    PrivacyTermsModal,
    Carousel,
    PaneView,
    snackbar
  },

  data () {
    return {
      email: '',
      snackText: '',
      color: 'green',
      snackbar: false
    }
  },

  methods: {
    submit () {
      axios
        .post('/security-api/sendPasswordReset', this.email, {
          headers: { 'content-type': 'text/plain' }
        })
        .then(resp => {
          if (resp.data.success) {
            this.snackText = `An email was sent to ${this.email} with instructions on how to reset your password`
            this.color = 'green'
          } else {
            this.snackText = `No account found for email address ${this.email}.`
            this.color = 'red'
          }
          this.snackbar = true
          setTimeout(() => {
            this.snackbar = false
          }, 5000)
        })
    }
  }
}
</script>
<style>
.back-btn-container {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 2;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.back-chevron {
  font-size: 2rem;
  color: #fff;
}
.back-text {
  color: #fff;
  font-size: 1.5rem;
  margin-left: -5px;
}
.copyright {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 20px 35px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}
.forgot-password-container {
  position: relative;
  z-index: 2;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
